import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';

export default (el, props) => {
    const $el = $(el);
    let flkty;

    const init = () => {
        flkty = new Flickity(el, {
            cellSelector: '[data-slide]',
            wrapAround: true,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            dragThreshold: 10,
            cellAlign: 'left',
            setGallerySize: true,
            percentPosition: true,
            accessibility: true,
            initialIndex: 0
        });
    };

    const destroy = () => {
        flkty.destroy();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/InstaSlider.js